import { POSTMessageBody, PUTMessageBody, PUTMessageStatusBody } from '.'
import { IPaginatedRequest } from '@cbgms/api/request'

export const listMessages = (params?: IPaginatedRequest) => ({
  method: 'GET',
  url: '/modules/system-messages',
  params
})

export const getMessage = (UUID: string) => ({
  method: 'GET',
  url: `/modules/system-messages/${UUID}`
})

export const createMessage = (data: POSTMessageBody) => ({
  method: 'POST',
  url: '/modules/system-messages',
  data
})

export const updateMessage = (UUID: string, data: PUTMessageBody) => ({
  method: 'PUT',
  url: `/modules/system-messages/${UUID}`,
  data
})

export const updateMessageStatus = (UUID: string, data: PUTMessageStatusBody) => ({
  method: 'PUT',
  url: `/modules/system-messages/${UUID}`,
  data
})
